module.exports = __webpack_public_path__ + "img/Figure_S1_protocal.ce2ab0f9.jpg";